<template>
  <div class="product__statuses">
    <div class="product__status product__status_theme_green"
         v-if="item.storage.first > elMaxView">
      Ближний {{ elMaxView }}+
    </div>
    <div class="product__status"
         :class="{'product__status_theme_green': item.storage.first > 0, 'product__status_theme_red': item.storage.first == 0}"
         v-if="item.storage.first <= elMaxView && item.storage.first >= 0">
      Ближний {{ item.storage.first }}
    </div>

    <div class="product__status product__status_theme_green"
         v-if="item.storage.second > elMaxView">
      Дальний {{ elMaxView }}+
    </div>
    <div class="product__status"
         :class="{'product__status_theme_green': item.storage.second > 0, 'product__status_theme_red': item.storage.second == 0}"
         v-if="item.storage.second <= elMaxView && item.storage.second >= 0">
      Дальний {{ item.storage.second }}
    </div>

    <div class="product__status product__status_theme_orange"
         v-if="item.storage.transit > elMaxView">
      {{ item.storage.transit_date }} ожидается {{ elMaxView }}+
    </div>
    <div class="product__status product__status_theme_orange"
         v-if="item.storage.transit <= elMaxView && item.storage.transit > 0">
      {{ item.storage.transit_date }} ожидается {{ item.storage.transit }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductStatuses",
  data: function () {
    return {
      elMaxView: 100,
    }
  },
  props: {
    item: {},
  },
}
</script>

<style scoped>

</style>